/*
 * Copyright (c) 2021. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import * as z from 'zod';
export const compoundVersionIdSchemaZ = z.tuple([z.uuid(), z.int()]);
export const componentVersionIdSchemaZ = z.object({
    id: z.uuid(),
    version: z.coerce.number().int(),
});
export const baseListComponentEntryKeys = [
    'id',
    'archived',
    'created_at',
    'created_by',
    'comments',
];
//# sourceMappingURL=components.js.map